import React, { Component } from 'react';
import { Query } from "react-apollo"
import gql from "graphql-tag"

const parseData = (data) => ({
  ...data,
  seo: JSON.parse(data.seo)
})

export default (getSlugFromProps, getPostType, renderNotFound = () => <h1>Not found</h1>) => WrappedComponent => class WithPost extends Component {
  render() {
    const slug = getSlugFromProps(this.props);
    const endpoint = getPostType(this.props);

    return (
      <Query
        query={gql`
            {
              ${endpoint}By(uri: "${slug}"){
                title
                seo
                slug
                colorScheme
                
                ancestors {
                  ...on Page {
                    title
                    uri
                  }
                }
                
                modules {
                  ...on Modules__hero {
                    layout
                    sellingPoints {
                      sellingPoint
                    }
                    cta
                    
                    image {
                      sourceUrl
                    }
                    
                    firstFeaturedImage {
                      sourceUrl
                    }
                    firstFeaturedText
                    firstFeaturedLink
                    
                    secondFeaturedImage {
                      sourceUrl
                    }
                    secondFeaturedText
                    secondFeaturedLink
                  }

                  ...on Modules__imageAndText {
                    layout
                    orientation
                    header
                    body
                    externalLink
                    link {
                      title
                      url
                    }
                    image {
                      sourceUrl
                    }
                  }

                  ...on Modules__grades {
                    layout
                  }

                  ...on Modules__electives {
                    layout
                    title
                    leadIn
                    content {
                      title
                      link
                      color
                      image {
                        sourceUrl
                      }
                    }
                    showInfobox
                    infoTitle
                    infoText
                    infoLink {
                      target
                      url
                      title
                    }
                    infoImage {
                      sourceUrl
                    }
                  }

                  ...on Modules__pageHeader {
                    layout
                    title
                    text
                    image {
                      sourceUrl
                    }
                  }

                  ...on Modules__wysiwyg {
                    layout
                    wysiwygContent
                  }

                  ...on Modules__image {
                    layout
                    image {
                      sourceUrl
                    }
                  }

                  ...on Modules__accordions {
                    layout
                    title
                    accordions {
                      title
                      text
                    }
                  }

                  ...on Modules__linkBoxes {
                    layout
                    boxes {
                      title
                      text
                      linkType
                      link
                      url
                      file {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__quotes {
                    layout
                    image {
                      sourceUrl
                    }
                    quotes {
                      quote
                      title
                      byline
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__videos {
                    layout
                    videos {
                      title
                      description
                      video
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__employees {
                    layout
                    showAll
                    employeeList {
                      id
                      title
                      position
                      email
                      text
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__grid {
                    layout
                    boxes {
                      text
                      link
                      color
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__daySlider {
                    layout
                    heading
                    times {
                      hours
                      minutes
                      title
                      text
                      image {
                        sourceUrl
                      }
                    }
                  }
                }
              }
            }`
        }
      >
        {({ loading, error, data }) => (
          <div>
            {!error && ( data[`${endpoint}By`] || loading ) &&
              <WrappedComponent
                {...this.props}
                loading={loading}
                post={data[`${endpoint}By`] && parseData(data[`${endpoint}By`])}
              />
            }
            {(error || (!loading && !data[`${endpoint}By`])) && renderNotFound()}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/withPost.js